import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { IdentityEvent } from '../../../common/events/identity'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityFormAPI } from './form-api'
import { IdentityFormUtils } from './form-utils'

export class PasswordlessEmailForm {
    private static DOM = {
        form: 'sendPasswordlessEmailForm'
    }
    private passwordlessSignInForm: HTMLFormElement
    private isSubmitted = false

    /**
     * Listens for the form validated event in the send passwordless email form
     */
    public init() {
        logger('debug', 'Initializing send passwordless email form')
        this.passwordlessSignInForm = document.querySelector(`[data-id-form=${PasswordlessEmailForm.DOM.form}]`)

        if (this.passwordlessSignInForm) {
            document.addEventListener(IdentityEvent.FORM_VALIDATED, async (event: CustomEvent) => {
                const formType = event.detail.form
                if (formType === PasswordlessEmailForm.DOM.form && !this.isSubmitted) {
                    // the form can be only submitted once so let's prevent further submissions
                    this.isSubmitted = true
                    try {
                        await this.submitForm()
                    } catch (e) {
                        // re-enable form submission if the form submission has failed
                        this.isSubmitted = false
                    }
                }
            })
        }
        logger('debug', 'Send passwordless email form initialized')
    }

    /**
     * Calls send passwordless email API
     */
    public async submitForm() {
        const formData = IdentityFormUtils.getFields()
        const email = formData.emailAddress
        const redirect = LoginService.getRedirectUrl(location.origin)

        const verificationUrlObj = new URL('/verify-passwordless/', location.origin)
        if (sessionStorage) {
            if (redirect.includes('/home-delivery/')) {
                verificationUrlObj.searchParams.append(
                    Store.CAMPAIGN, sessionStorage.getItem(Store.CAMPAIGN)
                )
                verificationUrlObj.searchParams.append(
                    Store.CAMPAIGN_NAME, sessionStorage.getItem(Store.CAMPAIGN_NAME)
                )
                verificationUrlObj.searchParams.append(
                    Store.OFFER_GROUP, sessionStorage.getItem(Store.OFFER_GROUP)
                )
            }
            // Checkout modal logic
            // If pianoParams are available then we need to pass them to ensure
            // that the checkout modal is shown on the final page.
            const pianoParams = sessionStorage.getItem(Store.PIANO_PARAMS)
            if (pianoParams) {
                verificationUrlObj.searchParams.append(
                    Store.PIANO_PARAMS, pianoParams
                )
            }
        }
        verificationUrlObj.searchParams.append('redirect', redirect)
        const verificationUrl = verificationUrlObj.toString()
        try {
            // call send passwordless link email API
            await IdentityFormAPI.sendPasswordlessEmail(
                {email, verification_url: verificationUrl}
            )

            // store email in session storage
            if (sessionStorage) {
                sessionStorage.setItem(
                    Store.PASSWORDLESS_EMAIL_ADDRESS, email
                )
            }
            // send form submission event
            LoginService.sendFormSubmissionEvent('send-passwordless-email')

            location.replace('/passwordless-email-sent/')
        } catch (err) {
            logger('error', 'Unable to send email containing passwordless login link', err)
            throw err
        }
    }
}
